import React from 'react';
import {FeaturesAnimationIcon} from './FeaturesAnimationIcon';
import {FeaturesIconEnum} from './featuresIcon.types';
import styled from 'styled-components';
import {AccentColorProps, useIsTwinmotionTheme} from 'epic-ue-theme';
import {FeaturesChatIcon} from './FeaturesChatIcon';
import {FeaturesContentIcon} from './FeaturesContentIcon';
import {FeaturesDevToolsIcon} from './FeaturesDevToolsIcon';
import {FeaturesGameplayIcon} from './FeaturesGameplayIcon';
import {FeaturesIntegratedMediaIcon} from './FeaturesIntegratedMediaIcon';
import {FeaturesLineIcon} from './FeaturesLineIcon';
import {FeaturesPipelineIcon} from './FeaturesPipelineIcon';
import {FeaturesPlatformSupportIcon} from './FeaturesPlatformSupportIcon';
import {FeaturesRenderingIcon} from './FeaturesRenderingIcon';
import {FeaturesSourceCodeIcon} from './FeaturesSourceCodeIcon';
import {FeaturesVfxIcon} from './FeaturesVfxIcon';
import {FeaturesWorldBuildingIcon} from './FeaturesWorldBuildingIcon';

const Styled = styled.div`
    width: 100%;
    height: 100%;
    svg {
        width: 100%;
        height: 100%;
    }
`;

export interface FeaturesIconProps {
    variant?: FeaturesIconEnum;
}

export const FeaturesIcon = ({
    variant,
    accentColor
}: FeaturesIconProps & AccentColorProps): JSX.Element | null => {
    const isTwinmotion = useIsTwinmotionTheme();
    const themedAccentColor = isTwinmotion ? 'orchid' : accentColor;
    let icon;
    switch (variant) {
        case FeaturesIconEnum.Animation:
            icon = <FeaturesAnimationIcon accentColor={themedAccentColor} />;
            break;
        case FeaturesIconEnum.BlankSpacer:
            return null;
        case FeaturesIconEnum.Chat:
            icon = <FeaturesChatIcon accentColor={themedAccentColor} />;
            break;
        case FeaturesIconEnum.Content:
            icon = <FeaturesContentIcon accentColor={themedAccentColor} />;
            break;
        case FeaturesIconEnum.DevTools:
            icon = <FeaturesDevToolsIcon accentColor={themedAccentColor} />;
            break;
        case FeaturesIconEnum.Gameplay:
            icon = <FeaturesGameplayIcon accentColor={themedAccentColor} />;
            break;
        case FeaturesIconEnum.IntegratedMedia:
            icon = <FeaturesIntegratedMediaIcon accentColor={themedAccentColor} />;
            break;
        case FeaturesIconEnum.Line:
            icon = <FeaturesLineIcon accentColor={themedAccentColor} />;
            break;
        case FeaturesIconEnum.Pipeline:
            icon = <FeaturesPipelineIcon accentColor={themedAccentColor} />;
            break;
        case FeaturesIconEnum.PlatformSupport:
            icon = <FeaturesPlatformSupportIcon accentColor={themedAccentColor} />;
            break;
        case FeaturesIconEnum.Rendering:
            icon = <FeaturesRenderingIcon accentColor={themedAccentColor} />;
            break;
        case FeaturesIconEnum.SourceCode:
            icon = <FeaturesSourceCodeIcon accentColor={themedAccentColor} />;
            break;
        case FeaturesIconEnum.Vfx:
            icon = <FeaturesVfxIcon accentColor={themedAccentColor} />;
            break;
        case FeaturesIconEnum.WorldBuilding:
            icon = <FeaturesWorldBuildingIcon accentColor={themedAccentColor} />;
            break;
        default:
            break;
    }

    return <Styled className={`features-icon icon-${variant}`}>{icon}</Styled>;
};
